var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _ = require('lodash');

var className = 'transition';

module.exports = function (_ref) {
  var standard = _ref.standard,
      transitions = _ref.transitions,
      variants = _ref.variants;
  return function (_ref2) {
    var addUtilities = _ref2.addUtilities,
        e = _ref2.e;

    var utilities = _.map(transitions, function (val, name) {
      return _defineProperty({}, ".".concat(e("".concat(className, "-").concat(name))), {
        transition: val
      });
    });

    if (standard) utilities = _.concat(utilities, _defineProperty({}, ".".concat(className), {
      transition: standard
    }));
    addUtilities(utilities, variants);
  };
};